module.exports = __webpack_public_path__ + "b4d9cbb0062a4f6af887e189fd13bf2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/7.png
// module id = 37
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18